export var MODAL_BUTTON_VARIANTS = {
  REGULAR: null,
  NAKED: "naked"
};